export default __webpack_public_path__ + "edc8548d4bf1d42ed137569151db7b0d.png";